/* Will change element's opacity depending on current scroll progress */
import { Directive, OnInit, OnDestroy, HostBinding, Input } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

import { Subscription, fromEvent, merge } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

@Directive({
    selector: '[directive-draw-content-margin]',
})
export class DrawContentMarginSharedDirective implements OnInit, OnDestroy {
    private _marginListener$: Subscription;
    @Input() public activeHeight: boolean = true;
    @HostBinding('style.marginTop.px') public marginTop: number = null;
    @HostBinding('style.transition') public transition: string = null;

    constructor(
        private _drawCollapseService: DrawCollapseService,
    ) {}

    ngOnInit(): void {
        if (!this.activeHeight) return;

        this._marginListener$ = merge(
            fromEvent(window, 'scroll'),
            this._drawCollapseService.drawDifference$,
            this._drawCollapseService.drawCurrentHeight$,
            this._drawCollapseService.drawProgress$,
        )
            .pipe(
                withLatestFrom(
                    fromEvent(window, 'scroll')
                        .pipe(
                            map(event => window.scrollY)
                        ),
                    this._drawCollapseService.drawProgress$,
                    this._drawCollapseService.drawCurrentHeight$,
                    this._drawCollapseService.drawDifference$,
                ),
            )
            .subscribe(([nextTrigger, nextScrollY, nextProgress, nextHeight, nextDiff]) => {
                this.marginTop = nextDiff;
            });
    }

    ngOnDestroy(): void {
        if (this._marginListener$ && !this._marginListener$.closed) this._marginListener$.unsubscribe();
    }
}
